<template>
	<div>
		<v-row
			class="prize-item prize-card-item"
			v-for="prize in prizes.entries"
			:key="prize.identifier"
			no-gutters
		>
			<v-col md="6" class="next-drawing-text prize-name">
				{{ prize.name }} - 1X :</v-col
			>
			<v-col md="6" class="amount">
				{{ prize.amount }}
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	name: 'PrizesCard',
	inject: ['contentStatus'],
	props: {
		prizes: {
			type: Object,
			required: true
		}
	}
};
</script>

<style lang="scss">
@import 'css/variables';

.prize-item {
	font-family: 'Made Tommy Bold', serif;
	padding: 6px;
	font-size: 1.2rem;

	> div {
		align-items: center;
		justify-content: center;
	}

	.prize-name {
		span {
			color: $blue;
			opacity: 0.9;
		}
	}

	.amount {
		color: $red;
		opacity: 0.9;
	}
}

.prize-card-item {
	border: solid 2px black;
	border-radius: 15px;
	margin: 15px;
}

.justify-content-space-evenly {
	justify-content: space-evenly;
}

.next-drawing-text {
	color: $blue;
}

.prize-name {
	align-items: center;
	display: flex;
}
</style>
